import script from "./RankItemList.vue?vue&type=script&setup=true&lang=js"
export * from "./RankItemList.vue?vue&type=script&setup=true&lang=js"

import "./RankItemList.vue?vue&type=style&index=0&id=1f1524be&scoped=true&lang=css"

import exportComponent from "/home/jenkins/storybird-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f1524be"]])

export default __exports__